import LegalPage from "@/pages/legal/components/LegalPage";
import { cookiePolicy } from "@/mocks/legal";

export default function Page() {
  return <LegalPage data={cookiePolicy} />;
}